import { brands, type designSystemTheme } from '@velasca/constants'

type DefaultTheme =
  | typeof designSystemTheme.man
  | typeof designSystemTheme.woman

type BrandThemeColors = DefaultTheme['colors']

interface MorphedTheme extends Omit<DefaultTheme, 'colors'> {
  colors: BrandThemeColors
}

type GetThemeByBrand = (originalTheme: DefaultTheme) => MorphedTheme

/**
 * See:
 * - https://github.com/microsoft/TypeScript/issues/31018.
 * - https://fettblog.eu/typescript-array-includes/.
 * - https://stackoverflow.com/questions/56565528/typescript-const-assertions-how-to-use-array-prototype-includes.
 */
const includes = <T extends U, U>(coll: readonly T[], el: U): el is T =>
  coll.includes(el as T)

/**
 * It generates a function that creates a morphed Theme to be passed to the ThemeProvider. The new theme has the same keys of the original one, but some values are replaced with different ones.
 *
 * @param brand - The brand to pass to the Context.
 */
export const getThemeByBrand = (brand?: string): GetThemeByBrand => {
  const setBrandTheme = (originalTheme: DefaultTheme) => {
    if (!brand || !includes(brands, brand)) {
      return {
        ...originalTheme,
        colors: originalTheme.brand.velasca.colors,
      }
    }

    return {
      ...originalTheme,
      colors: originalTheme.brand[brand].colors,
    }
  }

  return setBrandTheme
}
